import styled, { css } from 'styled-components';

interface IProps {
  posicao?: any;
  lenght: number;
  loading: boolean;
  playlist?: boolean;
}

export const Container = styled.div<IProps>`
  max-width: 100%;
  .infinite-scroll-component {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    justify-content: flex-start;

  .loadingWrapper {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .emptyPosts {
    height: min-content;
    position: absolute;
    width: calc(100% - 140px);
    max-width: fit-content;
    text-align: center;
  }

  ${(props) =>
    props.posicao === 'lateral' &&
    css`
      grid-template-columns: 1fr;
    `}

  width: 100%;

  ${(props) =>
    props.playlist &&
    css`
      width: 100%;
    `}

  .divLoading {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty-posts {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 300px;
    }
  }

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
`;
